import { render, staticRenderFns } from "./TgPage.vue?vue&type=template&id=1f14bc00&scoped=true"
import script from "./TgPage.vue?vue&type=script&lang=js"
export * from "./TgPage.vue?vue&type=script&lang=js"
import style0 from "./TgPage.vue?vue&type=style&index=0&id=1f14bc00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f14bc00",
  null
  
)

export default component.exports